module.exports = __webpack_public_path__ + "static/media/asembly.facf6ad6.jpg";